import { showFailureToast, showSuccessToast } from "@helpers";
import { createAction, createSlice } from "@reduxjs/toolkit";

const deleteDiscountSlice = createSlice({
  name: "deleteDiscount",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      showSuccessToast("Delete discount successful!");
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      showFailureToast("Delete discount successful!");
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = deleteDiscountSlice;
const deleteDiscountAction = createAction(name);

export {
  deleteDiscountAction,
  actions as deleteDiscountActions,
  reducer as deleteDiscountReducer,
};
